import { all, call, put, takeLatest, select } from 'redux-saga/effects';

import { ShopInfo } from 'actions/actionTypes';
import * as actions from 'actions/shop/shopInfo';

import { callShopInfo, callClientList, callEditShopInfo, callEditShopSalesInfo, callEditShopClientInfo, callShopLocations, callAllShopList } from 'network/apis/shop/shopInfo';
import { callImageUpload } from 'network/apis/common/upload';

function* loadShopInfoRequestSaga() {
    try {
        const manager = yield select((state) => state.manager);

        const response = yield call(callShopInfo, manager.manager.shopGuid);

        yield put(actions.loadShopInfoRequestSuccess(response.data));
    } catch (error) {
        yield put(actions.loadShopInfoRequestFailure(error.message));
    }
}

function* loadShopClientListRequestSaga() {
    try {
        const manager = yield select((state) => state.manager);

        const response = yield call(callClientList, manager.manager.shopGuid);

        yield put(actions.loadShopClientListRequestSuccess(response.data));
    } catch (error) {
        yield put(actions.loadShopClientListRequestFailure(error.message));
    }
}

function* editShopInfoRequestSaga() {
    try {
        const shopInfo = yield select((state) => state.shopInfo);

        const data = {
            shopOpenTime: shopInfo.data.shopOpenTime,
            shopCloseTime: shopInfo.data.shopCloseTime,
            isShopCloseNextDay: shopInfo.data.isShopCloseNextDay,
            isParking: shopInfo.data.isParking,
        };

        const response = yield call(callEditShopInfo, shopInfo.data.shopGuid, data);

        yield put(actions.editShopInfoRequestSuccess(response.data));

        alert('매장 정보 수정이 완료되었습니다.');
    } catch (error) {
        yield put(actions.editShopInfoRequestFailure(error.message));
    }
}

function* editShopSalesInfoRequestSaga() {
    try {
        const shopInfo = yield select((state) => state.shopInfo);

        const data = {
            [shopInfo.salesUpdate.key]: shopInfo.salesUpdate.value,
        };

        yield call(callEditShopSalesInfo, shopInfo.data.shopGuid, data);

        yield put(actions.editShopSalesInfoRequestSuccess());

        // 클라이언트 정보 수정 후 매장 클라이언트 정보 다시 조회
        yield put(actions.loadShopInfoRequest());
    } catch (error) {
        yield put(actions.editShopSalesInfoRequestFailure(error.message));
    }
}

function* editShopSalesImageRequestSaga() {
    try {
        const shopInfo = yield select((state) => state.shopInfo);

        const uploadData = new FormData();
        if (shopInfo.salesUpdate.key === 'operatingTimeImage') {
            uploadData.append('uploadType', 'operating_time_image');
        } else if (shopInfo.salesUpdate.key === 'shopViewImage') {
            uploadData.append('uploadType', 'shop_view_image');
        } else if (shopInfo.salesUpdate.key === 'parkingInformationImage') {
            uploadData.append('uploadType', 'parking_information_image');
        } else if (shopInfo.salesUpdate.key === 'shopIntroductionImage') {
            uploadData.append('uploadType', 'shop_introduction_image');
        }

        uploadData.append('file', shopInfo.salesUpdate.value);
        const uploadResponse = yield call(callImageUpload, uploadData);

        const uploadPath = uploadResponse.data.uploadFileList[0].uploadPath;
        const salesKey = shopInfo.salesUpdate.key;

        yield put(actions.editShopSalesInfoRequest(salesKey, [...shopInfo.data[salesKey], uploadPath]));
    } catch (error) {
        yield put(actions.editShopSalesImageRequestFailure(error.message));
    }
}

function* editShopClientInfoRequestSaga() {
    try {
        const shopInfo = yield select((state) => state.shopInfo);

        const data = {
            clientName: shopInfo.data.clientInfo.clientName,
            clientOrder: shopInfo.data.clientInfo.clientOrder,
        };

        const response = yield call(callEditShopClientInfo, shopInfo.data.shopGuid, shopInfo.data.clientInfo.clientGuid, data);

        yield put(actions.editShopClientInfoRequestSuccess(response.data));

        // 클라이언트 정보 수정 후 매장 클라이언트 정보 다시 조회
        yield put(actions.loadShopClientListRequest());

        alert('타석 정보 수정이 완료되었습니다.');
    } catch (error) {
        yield put(actions.editShopClientInfoRequestFailure(error.message));
    }
}

function* loadShopLocationsSaga() {
    try {
        const response = yield call(callShopLocations);

        yield put(actions.loadShopLocationsRequestSuccess(response.data));
    } catch (error) {
        yield put(actions.loadShopLocationsRequestFailure(error.message));
    }
}

function* loadAllShopListSaga() {
    try {
        const response = yield call(callAllShopList);

        yield put(actions.loadAllShopListRequestSuccess(response.data));
    } catch (error) {
        yield put(actions.loadAllShopListRequestFailure(error.message));
    }
}

// Sign-In Sagas
export default function* root() {
    yield all([
        takeLatest(ShopInfo.LOAD_SHOP_INFO_REQUEST, loadShopInfoRequestSaga),
        takeLatest(ShopInfo.LOAD_SHOP_CLIENT_LIST_REQUEST, loadShopClientListRequestSaga),

        takeLatest(ShopInfo.EDIT_SHOP_INFO_REQUEST, editShopInfoRequestSaga),
        takeLatest(ShopInfo.EDIT_SHOP_SALES_INFO_REQUEST, editShopSalesInfoRequestSaga),
        takeLatest(ShopInfo.EDIT_SHOP_SALES_IMAGE_REQUEST, editShopSalesImageRequestSaga),
        takeLatest(ShopInfo.EDIT_SHOP_CLIENT_INFO_REQUEST, editShopClientInfoRequestSaga),

        takeLatest(ShopInfo.LOAD_SHOP_LOCATIONS_REQUEST, loadShopLocationsSaga),

        takeLatest(ShopInfo.LOAD_ALL_SHOP_LIST_REQUEST, loadAllShopListSaga),
    ]);
}
